<template>
  <div class="organization-details-wrap">
    <v-btn text @click="$router.go(-1)" style="margin-left: -16px;">
      <v-icon left>mdi-chevron-left</v-icon>
      Back
    </v-btn>
    <div class="mb-7 mt-3 d-flex flex-wrap">
      <h2 class="headline">Newsletter Details</h2>
      <v-spacer></v-spacer>
    </div>
    <v-card>
      <v-simple-table v-if="!no_data.includes(newsletter)" :loading="loading" v-slot:default>
        <template>
          <thead>
          <tr>
            <th class="text-left">Details</th>
            <th class="text-left"></th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>ID</td>
            <td>
              <span v-if="!no_data.includes(newsletter.id)">{{ newsletter.id }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>
          <tr>
            <td>Name</td>
            <td>
              <span v-if="!no_data.includes(newsletter.name)">{{ newsletter.name }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>
          <tr>
            <td>Subject</td>
            <td>
              <span v-if="!no_data.includes(newsletter.subject)">{{ newsletter.subject }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>
          <tr>
            <td>Link</td>
            <td>
              <span v-if="!no_data.includes(newsletter.link)" @click="viewLink(newsletter.link)"
                    class="pointer action-link">{{ newsletter.link }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>
          <tr>
            <td>Campaign ID</td>
            <td>
              <span v-if="!no_data.includes(newsletter.campaign_id)">{{ newsletter.campaign_id }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>
          <tr>
            <td>Sent At</td>
            <td>
              <span v-if="!no_data.includes(newsletter.sent_at)">{{ newsletter.sent_at }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>
          <tr>
            <td>Total Clicks</td>
            <td>
              <span v-if="!no_data.includes(newsletter.total_clicks)">{{ newsletter.total_clicks }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>
          <tr>
            <td>Total Opens</td>
            <td>
              <span v-if="!no_data.includes(newsletter.total_opens)">{{ newsletter.total_opens }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <div class="mb-7 mt-3 d-flex flex-wrap">
      <h2 class="headline">Included advertisers info</h2>
      <v-spacer></v-spacer>
    </div>
    <v-card>
      <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :loading="loading"
          hide-default-footer="true"
          mobile-breakpoint="100"
          class="table-org"
      >
        <template v-for="h in headers" v-slot:[`header.${h.value}`]="{ header }">
          <v-tooltip top :disabled="!h.tooltip" :key="h.text">
            <template v-if="false">{{ header }}</template>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ h.text }}</span>
            </template>
            <span v-if="h.tooltip">{{ h.tooltip }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item="{item}">
          <tr class="items-body-row">
            <td>
              <span v-if="!no_data.includes(item.advertiser)">{{ item.advertiser }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.link)">{{ item.link }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.link_type)">{{ item.link_type }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.clicks)">{{ item.clicks }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
  name: 'NewsletterDetails',
  data: () => ({
    no_data: [null, "", undefined, "null"],
    newsletter: null,
    loading: false,
    headers: [
      {text: "Advertiser", tooltip: "Advertiser", value: "advertiser"},
      {text: "Link", tooltip: "Link", value: "link"},
      {text: "Link type", tooltip: "Link type", value: "link_type"},
      {text: "Clicks", tooltip: "Clicks", value: "clicks"},
    ],
    items: [],
    totalItems: 0,
    search: "",
    options: {},
    draw: 0,
    tableData: {
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 0,
      dir: "asc"
    },
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {}
  }),
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.loading = true;
      ApiService.get(`/admin/newsletter/${this.$route.params.id}/show`)
          .then(response => {
            this.newsletter = response.data.newsletter

            this.items = response.data.newsletter_clicks

            this.loading = false
          })
          .catch(error => {
            this.loading = false
            console.log(error.message);
          });
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, ' '))
    },
    viewLink(link) {
      window.open(link, '_blank')
    }
  }
}
</script>
